<template>
  <div class="flex flex-column v-center h-center" style="padding: 48px;">
    <div class="publish-container clr-blue">
      <i class="el-icon-s-promotion" />
    </div>
    <h2>发布成功!</h2>
  </div>
</template>
<script>
import { Icon } from "element-ui";
export default {
  name: "share-publish-icon",
  components: {
    [Icon.name]: Icon,
  },
};
</script>
<style scoped>
.publish-container {
  font-size: 48px;
  display: inline-flex;
  border: 2px solid;
  border-radius: calc(50%);
  padding: 12px;
}
</style>
